import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { TextField, makeStyles, Paper, MenuItem } from '@material-ui/core';
import deburr from 'lodash/deburr';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    // marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  inputRoot: {
    flexWrap: 'wrap',
  },
  inputInput: {
    width: 'auto',
    flexGrow: 1,
  },
  divider: {
    height: theme.spacing(2),
  },
}));


function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps;

  return (
    <TextField
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput,
        },
        ...InputProps,
      }}
      {...other}
    />
  );
}

renderInput.propTypes = {
  classes: PropTypes.object.isRequired,
  InputProps: PropTypes.object,
};


function renderSuggestion(suggestionProps) {
  const { suggestion, index, itemProps, highlightedIndex, selectedItem } = suggestionProps;
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem ? selectedItem.Name : '').indexOf(suggestion.Name) > -1;

  return (
    <MenuItem
      {...itemProps}
      key={suggestion.TwoLetterIsoCode}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 600 : 400,
      }}
    >
      {suggestion.Name}
    </MenuItem>
  );
}

renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number]).isRequired,
  index: PropTypes.number.isRequired,
  itemProps: PropTypes.object.isRequired,
  selectedItem: PropTypes.string.isRequired,
  suggestion: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
};



const CountryAutocompleteDS = (props) => {
  const classes = useStyles();

  const {
    values,
    touched,
    errors,
    handleBlur,
    setFieldValue,
    name,
    label,
    countries,
    margin = "dense",
    onSelectedOptionChange = (o) => {},
  } = props;
  const { t } = useTranslation();

  function getSuggestions(value, { showEmpty = false } = {}) {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0 && !showEmpty
      ? []
      : countries.filter(suggestion => {
          const keep =
            count < 5 && suggestion.Name.slice(0, inputLength).toLowerCase() === inputValue;

          if (keep) {
            count += 1;
          }

          return keep;
        });
  }

  const handleChange = (value) => {
    setFieldValue(name, value);
    onSelectedOptionChange(value);
  }

  return (
    <Downshift
      id="downshift-options"
      onChange={handleChange}
      itemToString={item => (item === null ? '' : item.Name)}
      selectedItem={values[name]}
      // initialSelectedItem={values[name]}
      // initialInputValue={values[name] ? values[name].Name : ''}
      >
    {({
      clearSelection,
      getInputProps,
      getItemProps,
      getLabelProps,
      getMenuProps,
      highlightedIndex,
      inputValue,
      isOpen,
      openMenu,
      selectedItem,
    }) => {
      const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
        onChange: event => {
          if (event.target.value === '') {
            clearSelection();
          }
        },
        onFocus: openMenu,
        onBlur: () => handleBlur(name),
        placeholder: 'Please select your country',
      });

      return (
        <div className={classes.container}>
          {renderInput({
            fullWidth: true,
            classes,
            label: t(label),
            InputLabelProps: getLabelProps({shrink: true}),
            InputProps: { onBlur, onChange, onFocus },
            error: errors[name] && touched[name],
            helperText: (t(errors[name])),
            margin: margin,
            inputProps
          })}

          <div {...getMenuProps()}>
            {isOpen ? (
              <Paper className={classes.paper} square>
                {getSuggestions(inputValue, { showEmpty: true }).map((suggestion, index) =>
                  renderSuggestion({
                    suggestion,
                    index,
                    itemProps: getItemProps({ item: suggestion }),
                    highlightedIndex,
                    selectedItem,
                  }),
                )}
              </Paper>
            ) : null}
          </div>
        </div>
      );
    }}
  </Downshift>
  );
};

export default CountryAutocompleteDS;